import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/logo";
import { VersionIndicator } from "@/components/ui/version-indicator";
import { Facebook, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-slate-200 mt-auto">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <Logo size="md" />
            <p className="text-slate-600 text-sm">
              Our AI creates professional, legally sound refund requests with the highest chance of success.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4 text-slate-900">Product</h3>
            <ul className="space-y-3">
              {[
                { label: "Features", path: "/features" },
                { label: "Pricing", path: "/pricing" },
                { label: "New Request", path: "/refund" },
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path}
                    className="text-slate-600 hover:text-primary text-sm transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4 text-slate-900">Support</h3>
            <ul className="space-y-3">
              {[
                { label: "FAQ", path: "/faq" },
                { label: "Contact Us", path: "/contact" },
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path}
                    className="text-slate-600 hover:text-primary text-sm transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4 text-slate-900">Legal</h3>
            <ul className="space-y-3">
              {[
                { label: "Privacy Policy", path: "/privacy" },
                { label: "Terms of Service", path: "/terms" },
                { label: "Cookie Policy", path: "/cookies" },
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path}
                    className="text-slate-600 hover:text-primary text-sm transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="pt-6 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <div className="flex flex-col md:flex-row items-center gap-2 mb-4 md:mb-0">
            <p>© {currentYear} SnapRefund by Timesy B.V. All rights reserved.</p>
            <span className="hidden md:inline text-slate-300">·</span>
            <p className="text-xs text-slate-400 tracking-wide">
              Designed & Developed by{" "}
              <a
                href="https://saroshstudio.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-primary after:transition-all after:duration-300 hover:after:w-full"
              >
                Sarosh Studio
              </a>
            </p>
            <VersionIndicator />
          </div>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a 
              href="https://www.facebook.com/profile.php?id=61577806666483" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors flex items-center gap-1"
            >
              <Facebook className="h-4 w-4" />
              Facebook
            </a>
            <a 
              href="https://instagram.com/snap.refund" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors flex items-center gap-1"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;